import { useState } from 'react';

import { FlexibleDiv } from '@components/formStyles';
import Markdown from '@components/utils/Markdown';

import { Description, ReadMore, ReadMoreWrapper } from './styled';

interface ReadMoreDescriptionProps {
  description: string;
  initialVisibleLength: number;
}

const ReadMoreDescription = ({
  description,
  initialVisibleLength = 300,
}: ReadMoreDescriptionProps) => {
  const [showFullDescription, setShowFullDescription] = useState(false);

  const toggleDescription = () => setShowFullDescription((val) => !val);

  const shortDescription =
    description?.length > initialVisibleLength
      ? description?.slice(0, initialVisibleLength)
      : description;
  return (
    <ReadMoreWrapper>
      <Description showFull={showFullDescription}>
        <Markdown text={showFullDescription ? description : shortDescription} />
      </Description>{' '}
      {description?.length > initialVisibleLength ? (
        <ReadMore onClick={toggleDescription}>
          {!showFullDescription ? 'Devamını Oku' : 'Daha Az Göster'}
        </ReadMore>
      ) : null}
      <FlexibleDiv bottom={30} />
    </ReadMoreWrapper>
  );
};

export default ReadMoreDescription;
